import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Brandsuk() {
  return (
    <section className="brands_uk p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <h2>
              The Distinguished Mobile App Development{" "}
              <span>Company in the UK</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <p>
              We do not simply build apps; we engineer experiences that resonate
              with user personas and business objectives to deliver exceptional
              experiences across platforms. Our result-driven{" "}
              <Link to="/uk/mobile-app-development-company-uk">
                mobile app development services in the UK
              </Link>{" "}
              helped us get recognised as a market-leader mobile, winning us
              credibility stars across top platforms.
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // autoplay={false}
              //   spaceBetween={20}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                768: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 3,
                },
                1366: {
                  slidesPerView: 4,
                },
                1600: {
                  slidesPerView: 6,
                },
              }}
              className="brands_logo_slider"
            >
              <SwiperSlide>
                <div className="brands_logo_app_item">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/brands/business_com.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={283}
                    height={60}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="brands_logo_app_item">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/brands/forbes.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={211}
                    height={60}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="brands_logo_app_item">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/brands/the_sun.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={138}
                    height={60}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="brands_logo_app_item">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/brands/inc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={151}
                    height={60}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="brands_logo_app_item">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/brands/nbc.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={62}
                    height={60}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="brands_logo_app_item">
                  <StaticImage
                    src="../../../images/location_new/uk-mobile/brands/press_wire.webp"
                    alt="TekRevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={246}
                    height={60}
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Brandsuk;
